import Vue from "vue";
import ElementUI, { Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./styles.css";
import App from "./App.vue";
import router from "./router";
import { formatDate, formatDateTime, formatShortDateTime } from "./utils/date";

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.filter("date", formatDate);
Vue.filter("dateTime", formatDateTime);
Vue.filter("shortDateTime", formatShortDateTime);
Vue.prototype.$formatDate = formatDate;
Vue.prototype.$formatDateTime = formatDateTime;
Vue.prototype.$formatShortDateTime = formatShortDateTime;

function getErrorMessage(error, fallback = "操作失败，请稍后重试") {
  if (!error) return fallback;
  if (error.__toastShown) return "";
  if (error.message) return error.message;
  if (typeof error === "string") return error;
  return fallback;
}

function showRuntimeError(error, fallback) {
  const message = getErrorMessage(error, fallback);
  if (!message) return;
  Message({
    type: "error",
    message,
    showClose: true,
    duration: 3000
  });
}

Vue.config.errorHandler = (error) => {
  showRuntimeError(error);
};

window.addEventListener("unhandledrejection", (event) => {
  showRuntimeError(event.reason);
  event.preventDefault();
});

window.addEventListener("error", (event) => {
  showRuntimeError(event.error || event.message);
  event.preventDefault();
});

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");
